import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { Weather } from '@app/flight-planning/flight-plan-constant';
import { FlightPlanService } from '@app/flight-planning/route-plan/services/flight-plan.service';
import { CommonService } from '@app/shared/services/common.service';
import { CreateScheduleService } from '@app/shared/services/create-schedule.service';

@Component({
    selector: 'app-weather',
    templateUrl: './weather.component.html',
    styleUrls: ['./weather.component.scss'],
    standalone: false
})
export class WeatherComponent implements OnInit {
  public weather = new Weather();
  public weatherListing: any;
  public viewSwitch = 0;
  public stationSwitch = 0;
  @Input() public type?: string;
  @Input() public iCAOCode?: string;
  @Input() public iCAOCodeSel?: string;

  public wxWeather: any;
  public wxWeathersel: any;

  constructor(public flightPlanService: FlightPlanService, private scheduleService: CreateScheduleService, private commonService: CommonService) { }

  public ngOnInit() {
    this.flightPlanService.flightPlanningAccordionOpenStatus = undefined;
  }
  public async ngAfterViewInit() {
    if (this.type == 'airportInfo') {
      this.commonService.showSpinnerLoader();
      try {
        const wxNotams = await this.scheduleService.getWsNotams(this.iCAOCode);
        this.wxWeather = wxNotams;

        const wxNotamsSel = await this.scheduleService.getWsNotams(this.iCAOCodeSel);
        this.wxWeathersel = wxNotamsSel;
        await this.commonService.dissmissSpinnerLoader();
      } catch (error) {
        await this.commonService.dissmissSpinnerLoader();
      }
    } else {
      this.commonService.showSpinnerLoader();

      this.flightPlanService.getWx().then((data) => {
        this.weatherListing = data;
        this.commonService.dissmissSpinnerLoader();
      }).catch((error) => {
        this.commonService.dissmissSpinnerLoader();
      });
    }
  }
  public openAccordian() {
    this.flightPlanService.accordionSwitch('weather');
  }
}
